import { GroupedListRenderer } from "../ui/grouped-list-renderer";
import { CommandItemTitle } from "./CommandItemTitle";
import { CommandItem } from "./types";

interface GroupedItem {
  title: string;
  items: CommandItem[];
}

interface CommandGroupRendererProps {
  groups: GroupedItem[];
  selectedIndex: number;
  onSelectItem: (globalIndex: number) => void;
  expandedGroups: Record<string, boolean>;
  onToggleExpand: (groupTitle: string) => void;
}

export const CommandGroupRenderer = ({
  groups,
  selectedIndex,
  onSelectItem,
  expandedGroups,
  onToggleExpand,
}: CommandGroupRendererProps) => {
  return (
    <GroupedListRenderer
      groups={groups}
      getItemKey={(item) => item.id}
      renderItem={(item) => (
        <CommandItemTitle label={item.label} unavailable={item.unavailable} />
      )}
      onSelectItem={() => {}}
      onSelectByIndex={onSelectItem}
      selectedIndex={selectedIndex}
      expandedGroups={expandedGroups}
      onToggleExpand={onToggleExpand}
    />
  );
};
